import { render, staticRenderFns } from "./safe-sku-chart.vue?vue&type=template&id=40c7cc84&scoped=true&"
import script from "./safe-sku-chart.vue?vue&type=script&lang=js&"
export * from "./safe-sku-chart.vue?vue&type=script&lang=js&"
import style0 from "./safe-sku-chart.vue?vue&type=style&index=0&id=40c7cc84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7cc84",
  null
  
)

export default component.exports